import { addLocaleData } from 'react-intl';
import enLocaleData from 'react-intl/locale-data/en';
import frLocaleData from 'react-intl/locale-data/fr';
import jaLocaleData from 'react-intl/locale-data/ja';
import esLocaleData from 'react-intl/locale-data/es';
import koLocaleData from 'react-intl/locale-data/ko';
import enTranslationMessages from '../translations/en.json';
import frTranslationMessages from '../translations/fr.json';
import jaTranslationMessages from '../translations/ja.json';
import esTranslationMessages from '../translations/es.json';
import koTranslationMessages from '../translations/ko.json';
import { formatTranslationMessages } from './utils';

addLocaleData(enLocaleData);
addLocaleData(frLocaleData);
addLocaleData(jaLocaleData);
addLocaleData(esLocaleData);
addLocaleData(koLocaleData);

export default {
  en: formatTranslationMessages('en', enTranslationMessages),
  fr: formatTranslationMessages('fr', frTranslationMessages),
  ja: formatTranslationMessages('ja', jaTranslationMessages),
  es: formatTranslationMessages('es', esTranslationMessages),
  ko: formatTranslationMessages('ko', koTranslationMessages),
};



// WEBPACK FOOTER //
// ./src/i18n/messages.js